import * as React from 'react';
import dashboardWrapper from '~/wrappers/dashboard';

const AuthorityLevelCreatePage = () => <div>AuthorityLevelCreate</div>;

export default dashboardWrapper(AuthorityLevelCreatePage);
